import styled from '@emotion/styled'

import { colors, spacing } from 'main/ui'

export const TitleContainer = styled.div`
  margin-bottom: ${spacing.majorScale(2)}px;
`

export const CalloutContainer = styled.div`
  :not(:first-child) {
    padding-top: ${spacing.majorScale(2)}px;
  }

  :not(:last-child) {
    border-bottom: 1px solid ${colors.border.default};
    padding-bottom: ${spacing.majorScale(2)}px;
  }
`
